import { CLOSE_ATTACHMENTS_SECTION, OPEN_ATTACHMENTS_SECTION } from '../../actions/types';

const conversationAttachmentsSection = (state = false, action) => {
  switch (action.type) {
    case OPEN_ATTACHMENTS_SECTION:
      return true;
    case CLOSE_ATTACHMENTS_SECTION:
      return false;
    default:
      return state;
  }
};

export default conversationAttachmentsSection;
